import { render } from "./adv.vue?vue&type=template&id=1fdeb173&scoped=true"
import script from "./adv.vue?vue&type=script&lang=js"
export * from "./adv.vue?vue&type=script&lang=js"

import "./adv.vue?vue&type=style&index=0&id=1fdeb173&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fdeb173"]])

export default __exports__